"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrettyTextStyles = void 0;
const react_1 = require("react");
const common_utils_1 = require("@zapier/common-utils");
const common_1 = require("../common");
const PrettyChoices_1 = __importDefault(require("../PrettyChoices"));
const EditablePrettyText_1 = __importDefault(require("./EditablePrettyText"));
const ReadOnlyPrettyText_1 = __importDefault(require("./ReadOnlyPrettyText"));
const useFocusCodeMirror_1 = __importDefault(require("./useFocusCodeMirror"));
const usePrettyTextReducer_1 = __importDefault(require("./usePrettyTextReducer"));
const VERTICAL_PADDING = '8px';
exports.PrettyTextStyles = common_utils_1.labelStyles(__filename, {
    psuedoInput: ({ isMultiline, isEditable, }) => [
        common_utils_1.withModifier('pretty-text', {
            height: 'auto',
            lineHeight: '20px',
        }),
        !isMultiline &&
            common_utils_1.withModifier('single-line-pretty-text', {
                minHeight: '40px',
                paddingTop: VERTICAL_PADDING,
                paddingBottom: VERTICAL_PADDING,
            }),
        isMultiline &&
            common_utils_1.withModifier('multiline-pretty-text', {
                minHeight: '80px',
            }),
        isMultiline &&
            !isEditable &&
            common_utils_1.withModifier('readonly-multiline-pretty-text', {}),
    ],
});
const PrettyText = (props) => {
    const { state, actions } = usePrettyTextReducer_1.default();
    const containerRef = react_1.useRef(null);
    const codeMirrorRef = react_1.useRef(null);
    const onInsertTag = (tag) => {
        if (codeMirrorRef.current) {
            codeMirrorRef.current.insertTag(tag);
            codeMirrorRef.current.focusCodeMirror();
        }
    };
    useFocusCodeMirror_1.default({ codeMirrorRef, isFocused: state.isFocused });
    const isActiveFieldRef = react_1.useRef(false);
    const onFocus = () => {
        isActiveFieldRef.current = true;
        actions.focus();
        props.onFocus();
    };
    const onBlur = (event) => {
        const didBlurWithin = containerRef.current &&
            containerRef.current.contains(event.relatedTarget);
        if (!didBlurWithin) {
            isActiveFieldRef.current = false;
            actions.blur();
            props.onBlur();
        }
    };
    const onFocusChoices = () => {
        actions.focusChoices();
        props.onFocus();
    };
    const onCloseChoices = () => {
        actions.closeChoices();
        props.onBlur();
    };
    const onChange = (newValue) => {
        const commit = !isActiveFieldRef.current;
        props.onChange(newValue, { commit });
    };
    return (common_utils_1.isolateComponent("div", { onBlur: onBlur, ref: containerRef, tabIndex: -1 },
        common_utils_1.isolateComponent(common_1.Input, { disabledText: props.disabledText, isDisabled: props.isDisabled, isErrored: props.isErrored }, (inputProps) => (common_utils_1.isolateComponent("div", { "aria-label": "edit field", css: [
                inputProps.css,
                exports.PrettyTextStyles.psuedoInput({
                    isMultiline: props.isMultiline,
                    isEditable: state.isEditable,
                }),
                { pointerEvents: inputProps.disabled ? 'none' : 'auto' },
            ], id: props.id, key: "psuedoInput", onFocus: onFocus, onMouseDown: actions.mouseDown, onMouseEnter: actions.mouseEnter, onTouchStart: actions.touchStart, role: "presentation", tabIndex: state.isEditable ? undefined : 0 }, state.isEditable ? (common_utils_1.isolateComponent(EditablePrettyText_1.default, Object.assign({}, props, { onChange: onChange, onClickTag: actions.clickTag, onEscape: onCloseChoices, ref: codeMirrorRef }))) : (common_utils_1.isolateComponent(ReadOnlyPrettyText_1.default, Object.assign({}, props)))))),
        props.choiceGroups && state.areChoicesOpen && (common_utils_1.isolateComponent(PrettyChoices_1.default, { choiceGroups: props.choiceGroups, onClickOutside: actions.clickOutsideChoices, onClose: onCloseChoices, onFocus: onFocusChoices, onInsertTag: onInsertTag }))));
};
PrettyText.defaultProps = {
    initialValue: '',
};
exports.default = PrettyText;
